import {
  LOG_IN,
  LOG_OUT,
  REFRESHING_TOKEN,
  SET_SESSION,
  UPDATE_SESSION,
  SYNC_FROM_STORAGE,
} from '../extra-constants/auth';

const authInitialStates = {
  currentNavigation: 'auth',
  session: {},
  type: '',
};

function authReducer(state = authInitialStates, action) {
  const { type, payload } = action;
  const actions = {
    [LOG_IN]: () => {
      // Add storage event listener to monitor persist:stb-web-app changes during login
      if (typeof window !== 'undefined') {
        const handleStorageChange = (event) => {
          if (event.key === 'persist:stb-web-app') {
            console.log('🔑 LOGIN - localStorage "persist:stb-web-app" changed:', {
              action: 'LOGIN_STORAGE_CHANGE',
              key: event.key,
              oldValue: event.oldValue ? JSON.parse(event.oldValue) : null,
              newValue: event.newValue ? JSON.parse(event.newValue) : null,
              timestamp: new Date().toISOString(),
            });
            // Remove listener after capturing the change
            window.removeEventListener('storage', handleStorageChange);
          }
        };
        window.addEventListener('storage', handleStorageChange);

        // Also log immediate state before change
        console.log('🔑 LOG_IN: About to update persist:stb-web-app', {
          beforeState: localStorage.getItem('persist:stb-web-app')
            ? JSON.parse(localStorage.getItem('persist:stb-web-app'))
            : null,
          timestamp: new Date().toISOString(),
        });
      }

      return {
        ...state,
        currentNavigation: 'main',
        action: type,
      };
    },
    [LOG_OUT]: () => {
      // Add storage event listener to monitor persist:stb-web-app changes during logout
      if (typeof window !== 'undefined') {
        const handleStorageChange = (event) => {
          if (event.key === 'persist:stb-web-app') {
            console.log('🚪 LOGOUT - localStorage "persist:stb-web-app" changed:', {
              action: 'LOGOUT_STORAGE_CHANGE',
              key: event.key,
              oldValue: event.oldValue ? JSON.parse(event.oldValue) : null,
              newValue: event.newValue ? JSON.parse(event.newValue) : null,
              timestamp: new Date().toISOString(),
            });
            // Remove listener after capturing the change
            window.removeEventListener('storage', handleStorageChange);
          }
        };
        window.addEventListener('storage', handleStorageChange);

        // Also log immediate state before change
        console.log('🚪 LOG_OUT: About to update persist:stb-web-app', {
          beforeState: localStorage.getItem('persist:stb-web-app')
            ? JSON.parse(localStorage.getItem('persist:stb-web-app'))
            : null,
          timestamp: new Date().toISOString(),
        });
      }

      return {
        ...state,
        currentNavigation: 'auth',
        session: {},
        action: type,
      };
    },
    [SET_SESSION]: () => ({
      ...state,
      session: {
        ...state.session,
        [payload.key]: payload.data,
      },
      action: type,
    }),
    [UPDATE_SESSION]: () => ({
      ...state,
      session: {
        ...state.session,
        user: {
          ...state.session.user,
          access_token: payload.access_token,
          refresh_token: payload.refresh_token,
        },
        expdate: payload.exp_date,
      },
      action: type,
    }),
    [REFRESHING_TOKEN]: () => ({
      ...state,
      action: type,
    }),
    [SYNC_FROM_STORAGE]: () => {
      // Sync state from localStorage when other tabs make changes
      if (typeof window !== 'undefined' && payload) {
        console.log('🔄 SYNC_FROM_STORAGE: Syncing auth state from localStorage', {
          previousState: state,
          newState: payload,
          timestamp: new Date().toISOString(),
        });
        return {
          ...state,
          ...payload,
          action: type,
        };
      }
      return state;
    },
  };

  return actions[type] ? actions[type]() : state;
}

export { authReducer };
